import { Modal } from 'components/Modal';
import { Title } from 'components/Title';
import React, { FC, useState } from 'react';
import styles from './OrderHistory.module.scss';
import { TabMenuFilter } from 'components/TabMenuFilter';

interface HistoryItem {
  datetime: string;
  text: string;
}

interface GroupedHistory {
  datetime: string;
  items: Array<{
    date: string;
    text: string;
  }>;
}

interface OrderHistoryProps {
  history?: HistoryItem[];
  assignHistory?: HistoryItem[];
  onClose: () => void;
  showButtons?: boolean;
}

export const OrderHistory: FC<OrderHistoryProps> = ({
  history = [],
  assignHistory = [],
  onClose,
  showButtons = false,
}) => {
  const [activeTab, setActiveTab] = useState('1');

  const tabList = [
    { key: '1', name: 'Заказ' },
    { key: '2', name: 'Отклики' },
  ];

  const groupedHistory = React.useMemo(() => {
    const groups: Record<string, GroupedHistory> = {};

    history.forEach((elem) => {
      const { datetime, ...rest } = elem;
      const dateSlice = datetime.split(' ').slice(0, 2).join(' ');

      if (!groups[dateSlice]) {
        groups[dateSlice] = {
          datetime: dateSlice,
          items: [],
        };
      }

      groups[dateSlice].items.push({
        date: datetime.split(' ').slice(2).join(''),
        ...rest,
      });
    });

    return Object.values(groups);
  }, [history]);

  const groupedAssignHistory = React.useMemo(() => {
    const groups: Record<string, GroupedHistory> = {};

    assignHistory.forEach((elem) => {
      const { datetime, ...rest } = elem;
      const dateSlice = datetime.split(' ').slice(0, 2).join(' ');

      if (!groups[dateSlice]) {
        groups[dateSlice] = {
          datetime: dateSlice,
          items: [],
        };
      }

      groups[dateSlice].items.push({
        date: datetime.split(' ').slice(2).join(''),
        ...rest,
      });
    });

    return Object.values(groups);
  }, [assignHistory]);

  return (
    <Modal open={true} setOpen={onClose}>
      <div className={styles.root_block}>
        <Title className={styles.root_history_title} title='История заказа' />
        {showButtons && (
          <TabMenuFilter
            active={activeTab}
            setActive={(tab: string) => {
              setActiveTab(tab);
            }}
            lists={tabList}
            fullWidth
          />
        )}

        {activeTab === '1' ? (
          <>
            {groupedHistory.map((group, groupIndex) => (
              <div key={groupIndex}>
                <p className={styles.root_date}>{group.datetime}</p>
                {group.items.map((item, itemIndex) => (
                  <div className={styles.root_block_text} key={itemIndex}>
                    <div className={styles.root_text}>
                      <Title
                        style={{
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '24px',
                        }}
                        title={item.text}
                      />
                      <p className={styles.root_datetext}>{item.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </>
        ) : groupedAssignHistory.length > 0 ? (
          <>
            {groupedAssignHistory.map((group, groupIndex) => (
              <div key={groupIndex}>
                <p className={styles.root_date}>{group.datetime}</p>
                {group.items.map((item, itemIndex) => (
                  <div className={styles.root_block_text} key={itemIndex}>
                    <div className={styles.root_text}>
                      <Title
                        style={{
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '24px',
                        }}
                        title={item.text}
                      />
                      <p className={styles.root_datetext}>{item.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </>
        ) : (
          <span className={styles.no_assign}>Никто не откликнулся на заказ.</span>
        )}
      </div>
    </Modal>
  );
};
